import React,{useState} from 'react'
import Title from '../layouts/Title';
import ContactLeft from './ContactLeft';

const scriptURL = 'https://script.google.com/macros/s/AKfycbycPDWknHnS3taWdLBNe36CB_icVsvzfmz6svHK1UjiqwgVEyVhGY5ROIZ5m8PVN_0mtg/exec'


const Contact = () => {
  // const [username, setUsername] = useState("");
  // const [phoneNumber, setPhoneNumber] = useState("");
  // const [email, setEmail] = useState("");
  // // const [subject, setSubject] = useState("");
  // const [message, setMessage] = useState("");
  const [errMsg, setErrMsg] = useState("");
  // const [successMsg, setSuccessMsg] = useState("");

  const form = document.forms['contact-form']

  //  ==========  Google Sheets Data function  =============
  const [formData, setFormData] = useState({
    userName: "",
    phoneNumber: "",
    email: "",
    message:"",
  });

  const handleChange = (e) => {
    // setFormData({ ...formData, [e.target.name]: e.target.value });
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value
    }))
    console.log('formData', formData)
  };
  


  // ========== Email Validation start here ==============
  const emailValidation = () => {
    return String(formData.email)
      .toLocaleLowerCase()
      .match(/^\w+([-]?\w+)*@\w+([-]?\w+)*(\.\w{2,3})+$/);
  };
  // ========== Email Validation end here ================

  const handleSend = (e) => {
    const {userName, phoneNumber, email, message} = formData
    e.preventDefault();
    if (userName === "") {
      setErrMsg("Username is required!");
    } else if (phoneNumber === "") {
      setErrMsg("Phone number is required!");
    } else if (email === "") {
      setErrMsg("Please give your Email!");
    } else if (!emailValidation(email)) {
      setErrMsg("Give a valid Email!");
     } 
    // else if (subject === "") {
    //   setErrMsg("Plese give your Subject!");
    // } 
    else if (message === "") {
      setErrMsg("Message is required!");
    } else {
      fetch(scriptURL, { method: 'POST', body: new FormData(form)})
      .then(response => alert("Thank you! your form is submitted successfully." )
      //   setSuccessMsg(
      //   `Thank you dear ${userName}, Your Messages has been sent Successfully!`
      // )
      )
      .then(() => { window.location.reload(); })
      .catch(error => console.error('Error!', error.message))
      // setSuccessMsg(
      //   `Thank you dear ${userName}, Your Messages has been sent Successfully!`
      // );
      setErrMsg("");
      setFormData({
        userName: '',
        phoneNumber: '',
        email:'',
        message: ''
      })
      // setUsername("");
      // setPhoneNumber("");
      // setEmail("");
      // // setSubject("");
      // setMessage("");
    }
  };

  

  return (
    <section
      id="contact"
      className="w-full py-20 border-b-[1px] border-b-black"
    >
      <div className="flex justify-center items-center text-center">
        <Title title="CONTACT" des="Contact Karate Guru" />
      </div>
      <div className="w-full">
        <div className="w-full h-auto flex flex-col lgl:flex-row justify-between">
          <ContactLeft />
          <div className="w-full lgl:w-[60%] h-full py-10 bg-gradient-to-r from-[#1e2024] to-[#23272b] flex flex-col gap-8 p-4 lgl:p-8 rounded-lg shadow-shadowOne">
            <form className="w-full flex flex-col gap-4 lgl:gap-6 py-2 lgl:py-5" 
            // onSubmit={handleSubmit}
            name="contact-form"
            >
              <div className="w-full flex flex-col lgl:flex-row gap-10">
                <div className="w-full lgl:w-1/2 flex flex-col gap-4">
                  {/* <p className="text-sm text-gray-400 uppercase tracking-wide">
                    Your name
                  </p> */}
                  <input
                    onChange={handleChange}
                    // value={username}
                    name="userName"
                    className={`${
                      errMsg === "Username is required!" &&
                      "outline-designColor"
                    } contactInput`}
                    type="text"
                    placeholder='Enter Your Name'
                  />
                </div>
                <div className="w-full lgl:w-1/2 flex flex-col gap-4">
                  {/* <p className="text-sm text-gray-400 uppercase tracking-wide">
                    Phone Number
                  </p> */}
                  <input
                    onChange={handleChange}
                    // value={phoneNumber}
                    className={`${
                      errMsg === "Phone number is required!" &&
                      "outline-designColor"
                    } contactInput`}
                    type="text"
                    name="phoneNumber"
                    placeholder='Enter mobile Number'
                  />
                </div>
              </div>
              <div className="flex flex-col gap-4">
                {/* <p className="text-sm text-gray-400 uppercase tracking-wide">
                  Email
                </p> */}
                <input
                  onChange={handleChange}
                  // value={email}
                  className={`${
                    errMsg === "Please give your Email!" &&
                    "outline-designColor"
                  } contactInput`}
                  type="email"
                  name="email"
                  placeholder='Enter Your Email'
                />
              </div>
              {/* <div className="flex flex-col gap-4">
                <p className="text-sm text-gray-400 uppercase tracking-wide">
                  Subject
                </p>
                <input
                  onChange={(e) => setSubject(e.target.value)}
                  value={subject}
                  className={`${
                    errMsg === "Plese give your Subject!" &&
                    "outline-designColor"
                  } contactInput`}
                  type="text"
                  placeholder='Enter Your Subject'
                />
              </div> */}
              <div className="flex flex-col gap-4">
                {/* <p className="text-sm text-gray-400 uppercase tracking-wide">
                  Message
                </p> */}
                <textarea
                  onChange={handleChange}
                  // value={message}
                  className={`${
                    errMsg === "Message is required!" && "outline-designColor"
                  } contactTextArea`}
                  cols="30"
                  rows="8"
                  name="message"
                  placeholder='Enter Your Message.. .'
                ></textarea>
              </div>
              <div className="w-full">
                <button
                  onClick={handleSend}
                  className="w-full h-12 bg-[#141518] rounded-lg text-base text-gray-400 tracking-wider uppercase hover:text-white duration-300 hover:border-[1px] hover:border-designColor border-transparent"
                  type="submit"
                >
                  Send Message
                </button>
              </div>
              {errMsg && (
                <p className="py-3 bg-gradient-to-r from-[#1e2024] to-[#23272b] shadow-shadowOne text-center text-orange-500 text-base tracking-wide animate-bounce">
                  {errMsg}
                </p>
              )}
              {/* {successMsg && (
                <p className="py-3 bg-gradient-to-r from-[#1e2024] to-[#23272b] shadow-shadowOne text-center text-green-500 text-base tracking-wide animate-bounce">
                  {successMsg}
                </p>
              )} */}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact